import styled from "styled-components"


export const FooterContainer = styled.ul`

    position:absolute;
    bottom:0;
    display:flex;
    height: 80px;
    background-color: #1D1D1D; 
    width:100%;
    overflow:hidden;
    justify-content:center;
    align-items:center;

`

export const FooterLink = styled.li`

    color:white;
    list-style-type: none;

`

export const FooterPlaceHolder = styled.div`
    flex:1;
    height:80px;
`